<template>
    <label id="timer-remaining-time-string"
        :class="[labelClass, 'timeri18n-label']"
    >
        {{ `${inTranslation} ${remainingTimeString}` }}
    </label>
</template>

<script>

import {
    getIntervalDuration, getRemainingTimeString,
} from '@shared/utils/timer';
import {
    intervalToDuration,
} from '@shared/utils/dates';

export default {
    name: 'timeri18n',
    props: {
        automationText: {
            type: String,
            default: '',
        },
        labelClass: {
            type: String,
            default: '',
        },
        inTranslation: {
            type: String,
            default: '',
        },
        endDate: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            interval: null,
            remainingTimeString: null,
            currentIntervalDuration: 1000,
            isTimerOver: false,
        };
    },
    created() {
        this.startTimer();
    },
    destroyed() {
        this.clearTimerInterval();
    },
    methods: {
        startTimer() {
            const duration = intervalToDuration({
                end: new Date(this.endDate),
                start: new Date(),
            });

            /* eslint-disable */
            this.currentIntervalDuration = getIntervalDuration(duration);
            // To prevent blink of null remainingTimeString
            this.setRemainingTimeString();

            this.interval = setInterval(() => {
                this.setRemainingTimeString();

                // We need this check to avoid start the timer once it's done
                if (!this.isTimerOver) {
                    this.clearTimerInterval();
                    this.startTimer();
                }
            }, this.currentIntervalDuration);
        },

        setRemainingTimeString() {
            this.remainingTimeString = getRemainingTimeString(new Date(this.endDate), () => {
                this.clearTimerInterval();
                this.isTimerOver = true;
                this.$emit('timerFinished');
            });
        },

        clearTimerInterval() {
            if (this.interval) {
                clearInterval(this.interval);
            }
        },
    },
};
</script>